<div id="printable-template-area" class="letter landscape">
  <div class="row">
    <div class="col-md-4">
      <img src="{{ clientConfig.assetImgDir + 'logo.png' }}" width="100%" alt="" />
    </div>
    <div class="col-md-8 contact">
      <h2> {{ clientConfig.phone }} <b>|</b> {{ clientConfig.email }}</h2>
    </div>
  </div>

  <div class="spacer">&nbsp;</div>
  <router-outlet></router-outlet>
  <div class="spacer">&nbsp;</div>
</div>
